import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_1: FaireProductEntity = {
  token: "catalog_prod_prod-1",
  type: "product",
  name: "Reversible Pillow - Happy Birthday",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 104.79,
  msrpDollars: 261.98,
  sku: "CO0001",
  caseSize: 2,
  material: "Linen",
  collectionToken: "col_confetti-cake",
  categoryTokens: ["catalog_cat_makeup"],
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 39,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
